import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import FullscreenToggle from './FullscreenToggle';
import { useAuth } from '../context/AuthContext';
import { Menu, FileText, LifeBuoy, LogOut } from 'lucide-react';
import MobileNav from './MobileNav';

export default function Header() {
  const { logout } = useAuth();
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <header className="relative mx-2 mt-3 mb-4 overflow-hidden rounded-3xl border border-white/20 bg-white/80 px-4 py-3 shadow-lg shadow-slate-900/5 backdrop-blur-xl transition dark:border-white/10 dark:bg-slate-900/70 dark:shadow-black/20">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(16,185,129,0.12),transparent_55%),radial-gradient(circle_at_bottom_left,rgba(56,189,248,0.12),transparent_55%)]" />
      <div className="relative flex items-center gap-4">
        <button
          onClick={() => setMobileOpen(true)}
          className="flex h-11 w-11 items-center justify-center rounded-2xl border border-white/40 bg-white/40 text-slate-700 transition hover:border-white/60 hover:bg-white/60 focus:outline-none focus:ring-2 focus:ring-emerald-400/60 dark:border-white/10 dark:bg-slate-900/60 dark:text-slate-100 dark:hover:border-white/20 dark:hover:bg-slate-900/50 md:hidden"
          aria-label="Open navigation"
        >
          <Menu className="h-5 w-5" />
        </button>

        <div className="flex flex-1 flex-col gap-1">
          <p className="text-base font-semibold text-slate-900 dark:text-white md:text-lg">Operational Command Hub</p>
          <span className="text-sm text-slate-500 dark:text-slate-300">Monitoring every asset in real time</span>
        </div>

        <div className="flex items-center gap-2 md:gap-3">
          <a
            href="https://demo-forms.digirockinnovations.com/equipment_form"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full border border-emerald-400/60 bg-gradient-to-r from-emerald-400 via-sky-400 to-blue-500 px-4 py-2 text-xs font-semibold text-emerald-950 shadow-lg shadow-emerald-500/30 transition hover:from-emerald-300 hover:via-sky-300 hover:to-blue-400 focus:outline-none focus:ring-2 focus:ring-emerald-300/60 dark:text-slate-950"
          >
            Forms
            <FileText className="h-4 w-4" />
          </a>
          <button className="inline-flex items-center gap-2 rounded-full border border-white/30 bg-white/50 px-4 py-2 text-xs font-semibold text-slate-700 transition hover:border-white/60 hover:bg-white/70 focus:outline-none focus:ring-2 focus:ring-sky-300/60 dark:border-white/10 dark:bg-white/10 dark:text-slate-100 dark:hover:border-white/20 dark:hover:bg-white/15">
            Support
            <LifeBuoy className="h-4 w-4" />
          </button>
          <button
            onClick={logout}
            className="hidden items-center gap-2 rounded-full border border-red-500/70 bg-gradient-to-r from-rose-500 via-red-500 to-amber-400 px-4 py-2 text-xs font-semibold text-white shadow-lg shadow-rose-500/30 transition hover:from-rose-400 hover:via-red-400 hover:to-amber-300 focus:outline-none focus:ring-2 focus:ring-rose-400/70 md:inline-flex"
          >
            Logout
            <LogOut className="h-4 w-4" />
          </button>
          <div className="hidden items-center rounded-2xl border border-white/30 bg-white/40 p-2 shadow-inner shadow-white/10 transition hover:border-white/50 hover:bg-white/60 dark:border-white/10 dark:bg-slate-900/60 dark:shadow-black/20 md:flex">
            <FullscreenToggle />
          </div>
        </div>
      </div>

      <MobileNav open={mobileOpen} onClose={() => setMobileOpen(false)} />
    </header>
  );
}
